import React from 'react'
import { TableCell, TableRow } from '@mui/material'
import { useSelector } from 'react-redux'
import { IProject } from '../../interface/IProjects'
import { IUser } from '../../interface/IUser'
import { formatTimeAsLocal } from '../../utils/functions/timeUtils'

const ReportDetailsLine = (props: any) => {
    const { row, hasTimeCard } = props as { row: any, hasTimeCard: boolean }
    const user: IUser = useSelector((state: any) => state.user?.value)
    const projects: IProject[] = useSelector((state: any) => state.projects?.value)
    const orders = useSelector((state: any) => state.orders?.value)

    const projectActivity = row.mserp_indirectactivitycategoryid !== 'SYSTEM'
    const projectId = projectActivity ? row.mserp_projectid : row.mserp_timeandattendancejobid
    const projectName = projects.find((item) => item.mserp_projectid === (projectActivity ? row.mserp_projectid : row.mserp_timeandattendancejobid))?.mserp_projectname
    const activityId = hasTimeCard ? row.mserp_timeandattendancejobid : row.mserp_activitynumber
    let activityName = projectActivity ? projects.find((item) => item.mserp_projectid === row.mserp_projectid)?.activities?.find((act) => act.mserp_jobid === row.mserp_timeandattendancejobid)?.mserp_description : projectName
    if (!hasTimeCard) {
        activityName = projects.find((item) => item.mserp_projectid === row.mserp_projectid)?.activities?.find((act) => act.mserp_activitynumber === row.mserp_activitynumber)?.mserp_description
    }
    const amount = hasTimeCard ? row.mserp_calculatedtimeseconds / 60.0 / 60.0 : row.mserp_hours
    const order = orders.find((item: any) => item.mserp_purchlinerecid === row.mserp_mbpurchlinerefrecid)
    const purchId = order ? order.mserp_purchid : ""
    const purchLineNumber = order ? order.mserp_linenumber : ""

    let from
    let to

    if (row.mserp_oncalltimeandattendancejobid === 'SE') {
        from = formatTimeAsLocal(row.mserp_startdatetime, row.mserp_timeprofiledate)
        to = formatTimeAsLocal(row.mserp_stopdatetime, row.mserp_timeprofiledate)
    }

    return (
        <TableRow key={row.date}>
            <TableCell sx={{ paddingY: 0.5, paddingX: 0 }} component="th" scope="row">
                {projectId} - {projectName}
            </TableCell>
            <TableCell sx={{ paddingY: 0.5, paddingX: 0 }}>
                {activityId} {activityName ? `- ${activityName}` : ''}
            </TableCell>
            <TableCell sx={{ paddingY: 0.5, paddingX: 0 }} align="right">
                {amount.toFixed(2)}
            </TableCell>
            {row.mserp_oncalltimeandattendancejobid === 'SE' && (
                <>
                    <TableCell sx={{ paddingY: 0.5, paddingX: 0 }} align="right">{from}</TableCell>
                    <TableCell sx={{ paddingY: 0.5, paddingX: 0 }} align="right">{to}</TableCell>
                </>
            )}
            {!hasTimeCard && (
                <TableCell sx={{ paddingY: 0.5, paddingX: 0 }} align="right">
                    {purchId} - {purchLineNumber}
                </TableCell>
            )}
            {user?.worker?.mserp_employmentcategory === 'ANÜ' ? <TableCell sx={{ paddingY: 0.5, paddingX: 0 }} align="right">{`${row.mserp_purchid} - ${row.mserp_purchlinenumber}`}</TableCell> : <></>}
        </TableRow>
    )
}

export default ReportDetailsLine
